function loadScript(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) { // IE
        script.onreadystatechange = function() {
            if (script.readyState == "loaded" || script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else { // Others
        script.onload = function() {
            callback();
        };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

document.addEventListener("DOMContentLoaded", function(event) {
    console.log('This is working', 'background: #FFFF0A; color: #000000')
    if ((typeof $ === 'undefined') && (typeof jQuery === 'undefined')) {
      loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function() {
        sales_rep_finder_map(jQuery);
      });
    }
    else{
      sales_rep_finder_map(jQuery);
    }
});

function sales_rep_finder_map($) {
    function loadStylesheet(href, cssId) {
        if (!document.getElementById(cssId)) {
            var head = document.getElementsByTagName('head')[0];
            var link = document.createElement('link');
            link.id = cssId;
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = href;
            link.media = 'all';
            head.appendChild(link);
            }
    }
    loadStylesheet('https://api.tiles.mapbox.com/mapbox-gl-js/v0.51.0/mapbox-gl.css', 'mapCSS');
    loadStylesheet('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v2.3.0/mapbox-gl-geocoder.css', 'mapGeoLoaderCSS');

    mapboxgl.accessToken = 'pk.eyJ1IjoianVzdGlubW9yZWxhbmQiLCJhIjoiNmZ5TG5WSSJ9.ZjcmcMQC6PIKXx6MylLgYw';
    var lastGeocode = "";
    var map = new mapboxgl.Map({
        container: 'sales-rep-map',
        style: 'mapbox://styles/justinmoreland/ck2anjrhn00701co4xbw5zwfz',
        center: [-91.759922, 45.475053],
        zoom: 5
    });
    var mapPopup = new mapboxgl.Popup();
    var geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        flyTo: false,
        placeholder: "Search by zip code or city"
    });
    map.addControl(geocoder);

    geocoder.on('result', function(result) {
        if (result.result.center.toString() !== lastGeocode) {
        mapPopup.remove();
            map.flyTo({
                center: result.result.center,
                zoom: 8,
                pitch: 0, // pitch in degrees
                bearing: 0,
            });
            map.once('moveend', function() {
                var mapContainer = $('#sales-rep-map');
                var mapWidth = mapContainer.outerWidth();
                var mapHeight = mapContainer.outerHeight();
                var features = map.queryRenderedFeatures([mapWidth / 2, mapHeight / 2], { layers: ['fire-safety-sales-reps'] });
                var property = features[0].properties
                showPopup(result.result.center, property.County, property.State, property.Name, property.Phone, property.Email)
            });
        }
        lastGeocode = result.result.center.toString();
    });

    map.on('load', function() {
        map.on('click', 'fire-safety-sales-reps', function(e) {
            mapPopup.remove();
            var property = e.features[0].properties
            setTimeout(function() {
                    showPopup(e.lngLat, property.County, property.State, property.Name, property.Phone, property.Email)
            }, 100);
        });

        // Change the cursor to a pointer when the mouse is over the states layer.
        map.on('mouseenter', 'fire-safety-sales-reps', function() {
            map.getCanvas().style.cursor = 'pointer';
        });

        // Change it back to a pointer when it leaves.
        map.on('mouseleave', 'fire-safety-sales-reps', function() {
            map.getCanvas().style.cursor = '';
        });
    });

    function showPopup(lngLat, county, state, name, phone, email) {
        mapPopup.setLngLat(lngLat).setHTML('<div class="county">' + county + ', ' + state + '</div><h3>' + name + '</h3> <p>' + phone + '<br> <a href="mailto:' + email + '">' + email + '</a></p>').addTo(map);
    }
}